import { useContext, useState } from "react";

import ClubStaffData from "./ClubStaffData";
import { ClubStaffContext } from "./ClubStaffContextProvider";

const useClubStaffData = () => {
  const [clubStaffState, setClubStaffState] = useContext(ClubStaffContext);
  const [clubStaffPutState, setClubStaffPutState] = useState(ClubStaffData.INITIAL_CLUB_STAFF_PUT_STATE);
  const [clubStaffPostState, setClubStaffPostState] = useState(ClubStaffData.INITIAL_CLUB_STAFF_POST_STATE);
  const [clubStaffDeleteState, setClubStaffDeleteState] = useState(ClubStaffData.INITIAL_CLUB_STAFF_DELETE_STATE);

  const postClubStaff = (orgUnitId, roleGroupId, clubStaffObj, removeRoles = true) => {
    return ClubStaffData.postClubStaffData(orgUnitId, roleGroupId, clubStaffObj, removeRoles, clubStaffPostState, setClubStaffPostState);
  };

  const getClubStaffMembers = (orgUnitId, roleGroupId, isCurrentOnly = true) => {
    return ClubStaffData.getClubStaffMembersData(orgUnitId, roleGroupId, isCurrentOnly, clubStaffState, setClubStaffState);
  };

  const putClubStaff = (orgUnitId, roleGroupId, personId, clubStaffObj) => {
    return ClubStaffData.putClubStaffData(orgUnitId, roleGroupId, personId, clubStaffObj, clubStaffPutState, setClubStaffPutState);
  };

  const deleteClubStaffRole = (personOrgRoleDurationId) => {
    return ClubStaffData.deleteClubStaffRoleData(personOrgRoleDurationId, clubStaffDeleteState, setClubStaffDeleteState);
  };

  const resetClubStaffState = () => {
    setClubStaffState({
      ...ClubStaffData.INITIAL_CLUB_STAFF_STATE
    });
  };

  return {
    clubStaffState,
    clubStaffPutState,
    clubStaffPostState,
    clubStaffDeleteState,
    postClubStaff,
    getClubStaffMembers,
    putClubStaff,
    deleteClubStaffRole,
    resetClubStaffState
  };
};

export default useClubStaffData;